export default {
  snackbar: {}
};
